<script>
  import Section from './comp/section.svelte';
  import VerticalSpacing from './comp/vertical-spacing.svelte';
  import Map from './comp/map.svelte';
  import Calendar from './comp/calendar.svelte';
  const dataCreater = (idKor, idEn, descMain, descSub) => {
    return {
      idKor: idKor,
      idEn: idEn,
      descMain: descMain,
      descSub: descSub,
    };
  };
  const data = dataCreater(
    '위치&일정',
    'Location & Schedules',
    ['구미역에서 5분,', '떠오르는 금리단길로'],
    ['구미역에서 도보로 5분!', '맛집과 카페가 많은 금리단길에 위치해 있어요.']
  );
</script>

<section class="container">
  <Section {...data} />
  <VerticalSpacing marginTop="120" />

  <div class="content-wrapper">
    <Map />
    <Calendar />
  </div>
</section>

<style>
  .container {
    width: 64%;
    /* width: 100%; */
    margin: 0 auto;
  }
  .content-wrapper {
    display: grid;
    grid-template-columns: 1fr 1fr;
  }

  @media screen and (max-width: 1300px) {
    .container {
      width: 90%;
    }
  }
  @media screen and (max-width: 768px) {
    .container {
      width: 96%;
      margin: 0 auto;
    }
    .content-wrapper {
      grid-template-columns: 1fr;
    }
  }
</style>
